module.exports = __webpack_public_path__ + "static/media/LogoIrinaBokova.f776f0d6.webp";